import { render, staticRenderFns } from "./ContinuedStayASAM.vue?vue&type=template&id=22995c52"
import script from "./ContinuedStayASAM.vue?vue&type=script&lang=js"
export * from "./ContinuedStayASAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports